import React, { useEffect, useState, Suspense, lazy, useCallback } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import { LABEL } from '../../veriables';
import { connect } from 'react-redux';
import EventEmitter from '@utility/eventSubscribers';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { flowType } from '@utility/userInfo';
import { ReactComponent as LockIcon } from '@assets/images/Lock.svg';
import cn from 'classnames';
import { bindActionCreators } from 'redux';
import {
  loyaltySignUp,
  loyaltySignIn,
  deleteLoyaltyAccount,
  applyLoyaltyOffer,
  handleLoyaltyInfo,
} from '@reducers/loyalty';
import { setPaymentCheck, setSeat } from '@reducers/orders';
import { setErrorPopUp } from '@reducers/notification';
import { openEmployeeCheck } from '@reducers/oauth';
import { TouchableDiv, TouchableCross } from '@components/common/Touchable';
const Loyalty = lazy(() => import('@components/Loyalty/indexCopy'));
const EmployeeCheck = lazy(() =>
  import('@components/checksCommon/employeeCheck')
);

const LoyaltyFlow = ({
  ShowLandscapeMode,
  setLoyaltyType,
  loyaltyType,
  checkAndSeats,
  ...props
}) => {
  const [tableData, setTableData] = useState(props.paymentCheck);
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const [loyaltyMethod, setLoyaltyMethod] = useState();
  const [joinMethod, setJoinMethod] = useState();
  const loyaltyInfo = props?.auth?.loyaltyInfo;
  const isServerApp = flowType() === 'serverApp';
  const isPaymentTerminal = flowType() === 'paymentTerminal';
  const isWalkUp = getObjectValue(
    () => props.seat && props.seat.sourceType === 7,
    false
  );
  const [countryCode, setCountryCode] = useState(() => {
    return getObjectValue(() => COUNTRY_CODE[props.auth.country].dialCode, '1');
  });
  const paymentCheck = getObjectValue(
    () => props.paymentCheck?.paymentCheck,
    {}
  );
  const lockPaymentScreen = getObjectValue(
    () =>
      (isServerApp || isPaymentTerminal) &&
      !isWalkUp &&
      props.auth.serverAppFeatures.lockPaymentScreen,
    false
  );
  const suppressOfferOnSplitByPerson = false;
  const supportsCoupon =
    !props?.auth?.loyaltyInfo?.supportsLoyalty &&
    props?.auth?.loyaltyInfo?.supportsCoupon;
  let isLoyaltyLogin = false;

  useEffect(() => {
    isLoyaltyLogin = props?.seat?.paymentCheck?.loyalty ? true : false;
  }, [props?.seat?.paymentCheck]);

  useEffect(() => {
    if (supportsCoupon) {
      setLoyaltyType(5);
    }
  }, []);

  const handleBackButton = () => {
    let temp = { isShow: false, url: () => {} };
    if ([2, 4, 5].includes(loyaltyType)) {
      if ([5].includes(loyaltyType)) {
        temp = {
          isShow: true,
          url: () => {
            setLoyaltyType(1);
            props.setPaymentFlowTypeLoyoltyBack();
          },
        };
      } else if ([2, 5].includes(loyaltyType)) {
        temp = { isShow: true, url: () => setLoyaltyType(1) };
      } else if (
        (loyaltyMethod === 'signIn' &&
          loyaltyInfo.lookupMethods &&
          loyaltyInfo.lookupMethods.length === 1) ||
        (loyaltyMethod === 'signUp' &&
          loyaltyInfo.signUpMethods &&
          loyaltyInfo.signUpMethods.length === 1)
      ) {
        temp = { isShow: true, url: () => setLoyaltyType(1) };
      } else {
        temp = { isShow: true, url: () => setLoyaltyType(2) };
      }
    } else if ([1].includes(loyaltyType)) {
      temp = {
        isShow: true,
        url: () => {
          setLoyaltyType(1);
          props.setPaymentFlowTypeLoyoltyBack();
        },
      };
    }
    return temp;
  };

  useEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(false);
    }
    setTableData(props.paymentCheck);
  }, [props.paymentCheck]);

  const renderModifier = modifiersObj =>
    (modifiersObj || []).map(modifier => (
      <div
        key={modifier.modifierId}
        className={modifier.price ? 'col-12 text-left p-0 fs-18' : 'd-none'}
      >
        {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${
          modifier.modifierName
        } ${
          modifier.price ? `(${currenySymbol}${modifier.price.toFixed(2)})` : ''
        }`}
        {(modifier.note || modifier.comment) && (
          <div className="pl-2">{modifier.note || modifier.comment}</div>
        )}
        {modifier.modifiers && modifier.modifiers.length > 0 && (
          <div className="pl-2">{renderModifier(modifier.modifiers)}</div>
        )}
      </div>
    ));

  const handleLoyaltyNotNow = isOfferAvailable => {
    props.handleSkipLoyalty(isOfferAvailable);
  };

  const handleLoyaltySignIn = type => {
    setLoyaltyMethod(type);
    setLoyaltyType(2);
  };


  const handleLoyaltySubmit = (inputData, fieldName) => {
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      countryCode,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.checkHeaderId,
      paymentCheck: props.seat?.paymentCheck || paymentCheck,
      paymentChecks: props.seat?.paymentChecks,
    };
    switch (fieldName) {
      case 'PhoneNumber':
        dataToSend = {
          ...dataToSend,
          loyalty: {
            phoneNumber: inputData,
            accountNumber: '',
            emailAddress: '',
            method: 'phone',
            countryCode,
          },
        };
        break;

      case 'AccountNumber':
        dataToSend = {
          ...dataToSend,
          accountNumber: inputData,
          phoneNumber: '',
          emailAddress: '',
          method: 'type',
        };
        break;

      default:
        dataToSend = {
          ...dataToSend,
          accountNumber: '',
          phoneNumber: '',
          emailAddress: inputData,
          method: 'email',
        };
        break;
    }
    if (loyaltyMethod === 'signIn') {
      props
        .loyaltySignIn(JSON.stringify(dataToSend))
        .then(res => {
          window.sessionStorage.setItem(
            'loyaltyData',
            JSON.stringify(res?.loyalty)
          );
          props.setPaymentCheck({
            ...res?.paymentCheck,
            loyalty: res?.loyalty,
            paymentCheck: res?.paymentCheck,
          });
          props.setSeat({
            ...props.seat,
            loyalty: res?.loyalty,
            paymentCheck: res?.paymentCheck,
            paymentChecks: res?.paymentChecks,
          });
          if (
            urlSearchParams('offer') == 'yes' &&
            res.loyalty.offers.length > 0
          ) {
            setLoyaltyType(3);
          } else {
            handleLoyaltyNotNow(false);
          }
        })
        .catch(err => {
          props.handleLoyaltyInfo({
            phoneNumber: null,
            email: null,
            type: null,
          });
          props.setErrorPopUp({
            res: err.message,
          });
        });
    } else if (loyaltyMethod === 'signUp') {
      props
        .loyaltySignUp(JSON.stringify(dataToSend))
        .then(res => {
          props.setPaymentCheck({
            ...res?.paymentCheck,
            loyalty: res?.loyalty,
            paymentCheck: res?.paymentCheck,
          });
          props.setSeat({
            ...props.seat,
            paymentCheck: res?.paymentCheck,
            paymentChecks: res?.paymentChecks,
          });
          if (
            urlSearchParams('offer') == 'yes' &&
            res.loyalty.offers.length > 0
          ) {
            setLoyaltyType(7);
          } else {
            handleLoyaltyNotNow(false);
          }
        })
        .catch(err => {
          props.setErrorPopUp({
            res: err.message,
          });
        });
    }
  };

  const getLoyaltyOffers = () => {};

  const handleApplyOffer = offer => {
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      loyalty: {
        accountNumber: props.seat?.paymentCheck?.loyalty.accountNumber,
      },
      offer: {
        vendorId: offer[0]?.vendorId,
        offerCode: offer[0]?.offerCode,
        offerAuthCode: null,
        name: offer[0]?.name,
        value: offer[0]?.value,
        quantity: offer[0]?.quantity,
        isCoupon: offer[0]?.isCoupon ? offer[0]?.isCoupon : false,
      },
      paymentCheck: props.seat.paymentCheck,
      paymentChecks: props.seat.paymentChecks,
    };
    props
      .applyLoyaltyOffer(dataToSend)
      .then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
          subTotalAmount: res?.paymentCheck?.subTotalAmount,
          totalAmount: res?.paymentCheck?.totalAmount,
          taxAmount: res?.paymentCheck?.taxAmount,
          itemAmount: res?.paymentCheck?.itemAmount,
        });
        props.setPaymentCheck({
          ...props.paymentCheck,
          paymentCheck: res.paymentCheck,
          subTotalAmount: res?.paymentCheck?.subTotalAmount,
          totalAmount: res?.paymentCheck?.totalAmount,
          taxAmount: res?.paymentCheck?.taxAmount,
          itemAmount: res?.paymentCheck?.itemAmount,
        });
        handleLoyaltyNotNow(false);
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const openLoyaltyKeyboard = type => {
    setJoinMethod(type);
    setLoyaltyType(4);
  };

  const handleRouteToCheckListing = () => {
    if (!lockPaymentScreen && isWalkUp) {
      props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true }); //added this line to redirect to orders for walkup only
    } else {
      props.openEmployeeCheck();
    }
  };

  const lockCallBack = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
      replace: true,
    });
  };

  const handleCountryCodeChange = e => {
    setCountryCode(e.id);
  };

  const handleCloseClick = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      handleRouteToCheckListing();
    },
    [handleRouteToCheckListing]
  );

  return (
    <div className={cn('col-12 col-md-12 p-0 row mx-0 h-100 rowReverse')}>
      {props.loading && <Loader />}
      <TouchableDiv
        className={cn(
          'position-fixed rounded d-flex justify-content-center align-items-center'
        )}
        style={{
          right: '1rem',
          top: '1rem',
          zIndex: '999',
          width: '2rem',
          height: '2rem',
          backgroundColor: props.serverAppTheme?.iconcolor_bg_box,
        }}
        role="presentation"
        onClick={e => handleCloseClick(e)}
      >
        {lockPaymentScreen ? (
          <LockIcon fill={props.serverAppTheme?.iconcolor} />
        ) : (
          <TouchableCross
            fill={props.serverAppTheme?.iconcolor}
            width={24}
            height={24}
            onClick={e => handleCloseClick(e)}
          />
        )}
      </TouchableDiv>
      <Suspense fallback={<Loader />}>
        <div
          className={cn(
            ShowLandscapeMode
              ? 'col-12 col-md-12 px-1 py-2'
              : 'col-12 col-md-6 px-0',
            isPaymentTerminal ? 'h-100' : lockPaymentScreen ? 'h-100' : 'h-100'
          )}
        >
          <div className={cn('mx-0 rounded', 'h-100')}>
            <Loyalty
              loyaltyType={loyaltyType}
              setPaymentFlowTypeLoyoltyBack={
                props.setPaymentFlowTypeLoyoltyBack
              }
              loyaltyInfo={loyaltyInfo}
              handleLoyaltyNotNow={handleLoyaltyNotNow}
              handleLoyaltySignIn={handleLoyaltySignIn}
              loyaltyMethod={loyaltyMethod}
              handleLoyaltySubmit={handleLoyaltySubmit}
              getLoyaltyOffers={getLoyaltyOffers}
              loyaltyOffers={props.loyaltyOffers}
              groupedLoyaltyOffers={
                !isLoyaltyLogin
                  ? props.groupedLoyaltyOffers
                  : props?.groupedNewLoyaltyOffers
              }
              handleApplyOffer={handleApplyOffer}
              joinMethod={joinMethod}
              openLoyaltyKeyboard={openLoyaltyKeyboard}
              countryCode={countryCode}
              handleBackButton={handleBackButton}
              accountLookup={props.accountLookup}
              deleteLoyalty={props.deleteLoyalty}
              handleCountryCodeChange={handleCountryCodeChange}
              isConfirmStageSplit={props.isConfirmStageSplit}
              suppressOfferOnSplitByPerson={suppressOfferOnSplitByPerson}
              ShowLandscapeMode={ShowLandscapeMode}
              serverAppTheme={props.serverAppTheme}
              seat={props.seat}
              handleLoyaltyInfo={props.handleLoyaltyInfo}
              checkAndSeats={checkAndSeats}
              setLoyaltyType={setLoyaltyType}
              setErrorPopUp={props.setErrorPopUp}
            />
          </div>
        </div>
      </Suspense>
      <Suspense fallback={<Loader />}>
        {props.isEmployeeCheck && (
          <EmployeeCheck
            {...props}
            callBack={lockCallBack}
            caseType={flowType()}
            isLandScape={ShowLandscapeMode}
            handleCloseCaseType={handleBackButton}
          />
        )}
      </Suspense>
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.loyalty.loading,
  auth: state.oauth.authInfo,
  paymentCheck: state.orders.paymentCheck,
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  loyaltyOffers: state.loyalty.loyaltyOffers,
  groupedLoyaltyOffers: state.loyalty.groupedLoyaltyOffers,
  groupedNewLoyaltyOffers: state.loyalty.groupedNewLoyaltyOffers,
  isEmployeeCheck: state.oauth.isEmployeeCheck,
  accountLookup: state.loyalty.accountLookup,
  isConfirmStageSplit: state.stage.isConfirmStageSplit,
  seat: state.orders.seats,
  serverAppTheme: state.theme.serverAppTheme,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPaymentCheck,
      openEmployeeCheck,
      deleteLoyaltyAccount,
      setErrorPopUp,
      loyaltySignUp,
      loyaltySignIn,
      setSeat,
      applyLoyaltyOffer,
      handleLoyaltyInfo,
    },
    dispatch
  );

const memoisedLoyaltyFlow = React.memo(LoyaltyFlow);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memoisedLoyaltyFlow);
